import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/chevron_left.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
